import { usePortalAuth } from '@/contexts/PortalAuthContext';
import { Navigate } from 'react-router-dom';

// Any authenticated, active staff member (Admin, Manager, Counter) may use the self-service portal.
export function ProtectedPortalRoute({ children }) {
  const { staff, loading } = usePortalAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-ink">Loading…</div>;
  if (!staff) return <Navigate to="/portal/login" replace />;
  return children;
}
